<template>
  <span class="loading-inline">
    <span :class="white ? 'spinner-white' : 'spinner-black'"></span>
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: "ui-loading-span",
  props: {
    white: Boolean,
  },
};
</script>

<style scoped>
.loading-inline {
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

/* ТВОЙ СПИННЕР БЕЗ ИЗМЕНЕНИЙ */
.spinner-white {
  width: 14px;
  height: 14px;
  margin: 0; /* убрал auto, чтобы не ломать выравнивание в строке */
  border: solid 2px transparent;
  border-top-color: #fff;
  border-left-color: rgb(255 255 255 / 0.3);
  border-right-color: rgb(255 255 255 / 0.3);
  border-bottom-color: rgb(255 255 255 / 0.3);
  border-radius: 50%;
  animation: pace-spinner 700ms linear infinite;
}

/* Чёрная версия — просто цвета поменял */
.spinner-black {
  width: 14px;
  height: 14px;
  margin: 0;
  border: solid 2px transparent;
  border-top-color: #004680;
  border-left-color: rgb(0 0 0 / 0.1);
  border-right-color: rgb(0 0 0 / 0.1);
  border-bottom-color: rgb(0 0 0 / 0.1);
  border-radius: 50%;
  animation: pace-spinner 700ms linear infinite;
}

/* Анимация */
@keyframes pace-spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>